RivalIQ.apps.Reports.module('curations.filters', function (filters, App, Backbone, Marionette, $, _) {
    'use strict';

    filters.loadScheduledReports = {
        action: function (curation) {

            if (!curation.scheduledReports) {

                return RivalIQ.export.data.reportSchedules.fetch().then(function (scheduledReports) {
                    curation.scheduledReports = scheduledReports;
                });
            }
        }
    };

    const EmptyView = Marionette.ItemView.extend({
        className: 'reports empty',
        template: '#emptyReportsTemplate'
    });

    filters.noScheduledReports = function (curation) {
        if (_.size(curation.scheduledReports) === 0) {
            return new EmptyView();
        }
    };

});
